<script setup lang="ts">
import FormLabel from '@/components/FormLabel/FormLabel.vue';
import { MayHaveAnyEntityChangeEvent, getEntityChangeEvent } from './entityChange.ts';
import EntityChange from '@/components/EntityHistory/EntityChange.vue';

defineProps<{
  entity: MayHaveAnyEntityChangeEvent;
}>();
</script>

<template>
  <div class="text-body-2">
    <FormLabel :label="$t('Added')" />
    <EntityChange :entityChange="getEntityChangeEvent(entity, 'created')" />

    <template v-if="entity.lastModifierUser">
      <FormLabel :label="$t('LastModification')" class="gutterTop" />
      <EntityChange :entityChange="getEntityChangeEvent(entity, 'modified')" />
    </template>
  </div>
</template>
